import './App.css';
import './styles/theme.css';
import './i18n';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './header';
import Footer from './components/footer';
import GreenBuilding from './components/greenconstruction';
import BMCServicePage from './components/Bmccomponent';
import ConstructionServicePage from './components/constructionservices';
import HassleFreeProcurementPage from './components/hassleFreeProcurementPage';
import OmanyePage from './components/homepage';
import PostConstruction from './components/postconstruction';
import TurnkeyProjects from './components/turnkeyprojects';
import ContactUs from './components/contactus';
import ServicesPage from './components/services';
import ProductsPage from './components/productdetails';
import Termsandcondition from './components/tnc';
import ProductDetails from './components/productvariety';
import ConstructionProducts from './components/constructiontwo';
import { QueryModalProvider } from './querycontext';
import ProductShowcase from './components/newshowcase';
import ProductCategories from './components/productcategoriespages';
import ProductSubcategories from './components/productsubcategories';
import ProductDetail from './components/productdetail';
import SubcategoryPage from './components/subcategorypage';
import NewCategoryPage from './components/newcategorypage';
import ScrollToTop from './components/scrolltop';
import MepProductGallery from './components/mepproducts';
import GlobalExpansion from './components/globalexpansion';
import AboutUs from './components/aboutus';
import FansAndExtractor from './components/fansandextractor';
import Test from './components/test';
import AllBlogsPage from './components/blogs';
import InteriorCarousel from './components/interiorcarausal';
import Products from './components/productscomponent';
import ProductsAll from './components/newproductvisible';
import NewProductsPage from './components/productsp';
import MepProductsPage from './components/mepproduct';
import TilingFLooring from './components/tilingflooring';
import TilingFlooring from './components/pcproducts';
import PaintingDecoration from './components/pcproducts';
import CeilingClading from './components/ceilingcladding';
import ToolsEquipments from './components/toolsequipement';
import FinishesDecorations from './components/finishdecoration';
import BuildingHardwarepage from './components/bmc';
import BuildingHardware from './components/bmc';
import GreenTechnology from './components/greentechnology';
import Accessories from './components/assessories';
import ConstructionChemical from './components/constructionchemical';
import LightingSolutions from './components/lightingsolution';
import LightingPage from './components/lightingsolution';
import TestingBg from './components/testttt';
import TeamIntroduction from './components/ourteam';

const App = () => {
  // Set your deadline (May 22, 2026)
  const expirationDate = new Date(2026, 6, 1); // Note: Months are 0-indexed (0 = January, 5 = June)
  const today = new Date();

  // If the date has passed, show the notice instead of the app
  if (today > expirationDate) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h2 style={styles.heading}>Access Period Expired</h2>
          <p style={styles.text}>
            The preview period for this project has ended. 
            Please contact the administrator for continued access.
          </p>
        </div>
      </div>
    );
  }

//   // Normal website content
//   return (
//     <div className="App">
//       <h1>Your Active Website</h1>
//       {/* Your components go here */}
//     </div>
//   );
// };


// function App() {
  return (
    <QueryModalProvider>
      <Router>
        <ScrollToTop />
        <Header />
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<OmanyePage />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/our-team" element={<TeamIntroduction />} />
          <Route path="/blogs" element={<AllBlogsPage />} />

          {/* Service Pages */}
          <Route path="/green-construction" element={<GreenBuilding />} />
          <Route path="/bmc-services" element={<BMCServicePage />} />
          <Route path="/construction-services" element={<ConstructionServicePage />} />
          <Route path="/hassle-free-procurement" element={<HassleFreeProcurementPage />} />
          <Route path="/post-construction" element={<PostConstruction />} />
          <Route path="/global-expansion" element={<GlobalExpansion />} />
          <Route path="/turnkey-projects" element={<TurnkeyProjects />} />
          <Route path="/our-services" element={<ServicesPage />} />

          {/* Product Pages */}
          <Route path="/our-products" element={<NewProductsPage />} />
          <Route path="/product-categories" element={<ProductCategories />} />
          <Route path="/products-detail" element={<ProductsPage />} />
          <Route path="/products-details" element={<ProductDetails />} />
          <Route path="/our-products/:id" element={<ProductSubcategories />} />
          <Route path="/our-products/:category/subcategory/:subcategory" element={<SubcategoryPage />} />
          <Route path="/our-products/:category/:productId" element={<ProductDetail />} />
          {/* New unified routes (do not modify legacy components) */}
          <Route path="/new-products/:id" element={<NewCategoryPage />} />
          <Route path="/new-products/:category/:productId" element={<ProductDetail />} />

          {/* Legal Pages */}
          <Route path="/terms_conditions" element={<Termsandcondition />} />

          {/* Product Category Routes */}
          <Route path="products/mep_products" element={<MepProductsPage />} />
          <Route path="products/tiling_flooring_products" element={<TilingFLooring />} />
          <Route path="products/painting_decoration_products" element={<PaintingDecoration />} />
          <Route path="products/ceiling_cladding_products" element={<CeilingClading />} />
          <Route path="products/tools_equipment_products" element={<ToolsEquipments />} />
          <Route path="products/finishes_decoration_products" element={<FinishesDecorations />} />
          <Route path="products/building_hardware_products" element={<BuildingHardware />} />
          <Route path="products/sustainable_green_solution" element={<GreenTechnology />} />
          <Route path="products/accessories" element={<Accessories />} />
          <Route path="products/construction_chemical" element={<ConstructionChemical />} />
          <Route path="products/lightingsolutions" element={<LightingPage />} />

          {/* Commented Out Routes (for future use) */}
          {/* <Route path="/our-products/mep_products/mep_products" element={<MepProductGallery />} /> */}
          {/* <Route path="/our-products/contact-us" element={<ContactUs />} /> */}
          {/* <Route path="/fans_and_extractor" element={<FansAndExtractor />} /> */}
          {/* <Route path="/test" element={<ProductsAll />} /> */}

          {/* Catch-all route that redirects to contact-us */}
          {/* <Route path="*" element={<Navigate to="/contact-us" replace />} /> */}
        </Routes>
        <Footer />
      </Router>
    </QueryModalProvider>
  );
}


// Simple inline styles for the "Blank" state
const styles = {
  container: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f4f4f4',
    fontFamily: 'sans-serif',
    textAlign: 'center',
    padding: '20px'
  },
  card: {
    padding: '40px',
    background: '#fff',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    maxWidth: '400px'
  },
  heading: {
    color: '#333',
    marginBottom: '10px'
  },
  text: {
    color: '#666',
    lineHeight: '1.5'
  }
};

export default App;